import Accordion from '@app/components/common/Accordion';
import ReportSettingsSection from '../../../ReportForm/ReportSettingsSection';
import ReportSchedulingSection from '../../../ReportForm/ReportSchedulingSection';

const CustomReportsSettings = () => {
  return (
    <>
      <Accordion>
        <ReportSettingsSection isExpanded bucket="customReports" />
        <ReportSchedulingSection />
      </Accordion>
    </>
  );
};

export default CustomReportsSettings;
